// extracted by mini-css-extract-plugin
module.exports = {"center":"Text_center__rizC-","link":"Text_link__3UkKM"};